module.exports = __webpack_public_path__ + "static/fonts/4bfd13a9-3195-4d8f-87a9-83a212d18b16.a00cb26.woff2";